<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'samples'"
      :items="items"
      :loading="loading"
      :display-name-plural="$t('entities.PendingSample.Plural')"
      :display-name-singular="$t('entities.PendingSample.Singular')"
      :permission-name="'Samples'"
      :allow-delete="false"
      :items-per-page="itemsPerPage"
      :allow-create="false"
      :exclude-fields="['id', 'customerId', 'status']">
      <template #cell(hasBarcode)="row">
        {{ $t('common.'+row.item.hasBarcode) }}
      </template>
      <template #extraTableActions>
        <b-button
          class="ml-2"
          variant="primary"
          @click="$refs.scanModal.show(); $barcodeScanner.init(sendSample)"
          v-if="$auth.check(
            'Permissions.AdminPanel.Samples.Edit'
          )">
          {{ $t('common.ScanButton') }}
        </b-button>
      </template>
      <template #extraActions="row">
        <el-tooltip
          :content="'Přiradit čárový kód'"
          :enterable="false"
          placement="top">
          <b-button class="downloadBtn mx-1"
                    @click="$refs.scanModal.show(); currentlyScanning = row.item.id; $barcodeScanner.init(scanBarcode)">
            <font-awesome-icon class="fa-xs"
                               icon="barcode" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="'Stáhnout štítek s adresou'"
          :enterable="false"
          placement="top">
          <b-button class="downloadAddressBtn mx-1"
                    @click="download(row.item)">
            <font-awesome-icon class="fa-xs"
                               icon="address-card" />
          </b-button>
        </el-tooltip>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="scanModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ScanBarcode') }}
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="$refs.scanModal.hide(); currentlyScanning = 0; $barcodeScanner.destroy()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="downloadModal"
             centered
             :ok-disabled="true"
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.Downloading') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        Stahování štítku s adresou...
      </p>
      <div id="nprogressDownload"
           style="height:25px" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="cancelDownload(); $refs.downloadModal.hide()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import NProgress from 'nprogress/nprogress';
import { downloadBlob } from '@utils/downloadBlob';

export default {
  components: {
    DataTable
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
      source: null,
    }
  },
  data() {
    return {
      items: [],
      loading: false,
      currentlyScanning: 0
    };
  },
  created() {
    this.reload();
    this.source = this.axios.CancelToken.source();
  },
  methods: {
    reload() {
      this.loading = true;
      this.axios.get('/admin/samples/pending')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.items = res.data.result;
          } else {
            this.items = [];
          }
          this.loading = false;
        }).catch((err) => Promise.reject(err)).finally(() => {
          this.$refs.DataTable.finishSpinner();
        });
    },
    scanBarcode(code) {
      this.axios.post('admin/barcodes/assign', {
        CustomerId: this.currentlyScanning,
        Code: code
      }).then((response) => {
        this.$refs.DataTable.refresh();
        this.$root.$bvToast.toast('Čárový kód úspěšně přirazen', {
          title: 'Úspěch',
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        Promise.resolve(response);
      }).catch((err) => {
        this.$root.$bvToast.toast('Nepodařilo se přiradit čárový kód', {
          title: 'Nepodařilo se přiradit',
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        Promise.reject(err);
      });
    },
    cancelDownload() {
      this.source.cancel();
      this.source = this.axios.CancelToken.source();
    },
    download(item) {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/samples/getaddresslabel', {
        params: {
          CustomerId: item.customerId
        },
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        downloadBlob(response.data, `Adresa ${item.customerName}`, 'image/png');
        this.$refs.downloadModal.hide();
      })
        .catch((thrown) => {
          if (this.axios.isCancel(thrown)) {
            this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
              title: this.$t('common.Cancelled'),
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            });
            this.$refs.downloadModal.hide();
          }
        })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    },
    sendSample(code) {
      this.axios.post('/admin/samples/send', {
        Barcode: code
      })
        .then((res) => {
          this.$refs.DataTable.refresh();
          this.$root.$bvToast.toast('Vzorek úspěšně odeslán', {
            title: 'Úspěch',
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          Promise.resolve(res);
        }).catch((err) => {
          this.$root.$bvToast.toast('Vzorek se nepodařilo odeslat', {
            title: 'Nepodařilo se odeslat',
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          Promise.reject(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.downloadAddressBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #dfaf2d;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}
</style>
